import moment from 'moment-timezone';

//Available Vehicle Selected -> Calculation Start
export const getTheTotalAmountOnVehicleClassIsSelected = (selectedVehicleClassData: any) => {
    let totalPrice = 0.0;
    let totalHours = 0;
    let hourlyRate = 0.0;
    let totalDays = 0;
    let dailyRate = 0.0;
    let totalWeeks = 0;
    let weeklyRate = 0.0;
    let totalMonths = 0;
    let monthilyRate = 0.0;

    hourlyRate = selectedVehicleClassData?.hourlyRate || 0.0;
    dailyRate = selectedVehicleClassData?.dailyRate || 0.0;
    weeklyRate = selectedVehicleClassData?.weeklyRate || 0.0;
    monthilyRate = selectedVehicleClassData?.monthilyRate || 0.0;

    totalHours = selectedVehicleClassData?.hours || 0.0;

    if (selectedVehicleClassData?.days >= 30) {
        totalPrice = (
            parseInt((parseInt(selectedVehicleClassData?.days) / 30).toFixed(0)) * Number(selectedVehicleClassData?.monthilyRate)
            + parseInt(parseInt((parseInt(selectedVehicleClassData?.days) % 30) + "") / 7 + "") * Number(selectedVehicleClassData?.weeklyRate)
            + parseInt(((parseInt(selectedVehicleClassData?.days) % 30) % 7).toFixed(0)) * Number(selectedVehicleClassData?.dailyRate)
            + parseFloat(selectedVehicleClassData?.hours) * Number(selectedVehicleClassData?.hourlyRate)
        );

        totalMonths = parseInt(selectedVehicleClassData?.days / 30 + "");
        totalWeeks = parseInt(parseInt((selectedVehicleClassData?.days % 30) + "") / 7 + "");
        totalDays = parseInt((parseInt((selectedVehicleClassData?.days % 30) + "") % 7) + "");
    } else if (selectedVehicleClassData?.days >= 7) {
        totalPrice = (
            parseInt((parseInt(selectedVehicleClassData.days) / 7).toFixed(0)) * Number(selectedVehicleClassData.weeklyRate)
            + parseInt((parseInt(selectedVehicleClassData.days) % 7).toFixed(0)) * Number(selectedVehicleClassData.dailyRate)
            + parseFloat(selectedVehicleClassData.hours) * Number(selectedVehicleClassData.hourlyRate)
        );

        totalWeeks = parseInt(selectedVehicleClassData?.days / 7 + "");
        totalDays = parseInt((selectedVehicleClassData?.days % 7) + "");
    } else {
        totalPrice = (
            parseFloat(selectedVehicleClassData?.days) * Number(selectedVehicleClassData?.dailyRate) +
            parseFloat(selectedVehicleClassData?.hours) * Number(selectedVehicleClassData?.hourlyRate)
        );

        totalDays = parseInt((selectedVehicleClassData?.days % 7) + "");
    }

    return {
        totalPrice,
        totalHours,
        hourlyRate,
        totalDays,
        dailyRate,
        totalWeeks,
        weeklyRate,
        totalMonths,
        monthilyRate
    };
}

export const calculateTheBasePriceOfAdjustment = (extraValue: any, totalAmountOfSelectedVehicleClass: number, totalDays: number) => {
    let basePriceOfAdjustment = 0.0;

    if (extraValue?.reservationAdditionalId > 0) {
        basePriceOfAdjustment = extraValue?.basePrice;
    } else {
        const amountOrPercentage = (extraValue.chargeType === "Amount"
            ? extraValue?.anountOrPercentage
            : (totalAmountOfSelectedVehicleClass *
                parseFloat(extraValue?.anountOrPercentage)) /
            100);

        basePriceOfAdjustment = (extraValue?.selectionType === "Only One"
            ? amountOrPercentage
            : totalDays *
            parseFloat(amountOrPercentage)
        );
    }

    return basePriceOfAdjustment;
}

export const getTheCheckAdditionalCharges = (updatedExtraData: any[]) => {
    let additionalValue: any[] = [];
    const updatedCheckExtraData = updatedExtraData.map((item: any) => {
        const additionalCharges = item?.additionalCharges
            ?.filter((value: any) => value?.isChecked)

        if (additionalCharges?.length > 0) {
            additionalValue = [...additionalValue, ...additionalCharges];
            return {
                ...item,
                additionalCharges
            };
        } else {
            return null;
        }
    })
        ?.filter((item: any) => item !== null);

    return updatedCheckExtraData;
}

export const getTheCheckExtraValue = (updatedExtraData: any[], totalAmountOfSelectedVehicleClass: number, totalDays: number) => {
    let additionalValue: any[] = [];
    const updatedCheckExtraData = updatedExtraData.map((item: any) => {
        const additionalCharges = item?.additionalCharges
            ?.filter((value: any) => value?.isChecked)
            ?.map((value: any) => {
                const basePrice = calculateTheBasePriceOfAdjustment(value, totalAmountOfSelectedVehicleClass, totalDays);

                return {
                    ...value,
                    basePrice: basePrice
                }
            });

        if (additionalCharges?.length > 0) {
            additionalValue = [...additionalValue, ...additionalCharges];
            return {
                ...item,
                additionalCharges
            };
        } else {
            return null;
        }
    })
        ?.filter((item: any) => item !== null);

    let addedAjustmentAmount = 0.0;
    addedAjustmentAmount = getTotalAmountOfAdditionalCharges(
        additionalValue?.map((item: any) => {
            return {
                quantity: item?.quantity,
                basePrice: item?.basePrice
            }
        })
    );

    return { addedAjustmentAmount, updatedCheckExtraData };
}

const getTotalAmountOfAdditionalCharges = (adjustmentValue: any[]) => {
    let totalAdditionalChargeAmount = 0.0;
    adjustmentValue.forEach((item: any) => {
        const amount = parseFloat(item?.basePrice);
        if (!isNaN(amount)) {
            totalAdditionalChargeAmount += (item?.quantity * amount);
        }
    });

    return totalAdditionalChargeAmount;
}

//ExtraMileCharge -> Calculation Start
export const calculateForExtraMiles = (totalDays: number, totalWeeks: number, totalMonths: number, selectedVehicleClassData: any) => {
    let includedMiles = 0;

    includedMiles = (totalDays * selectedVehicleClassData?.distanceLimitperDay)
        + (totalWeeks * selectedVehicleClassData?.distanceLimitperWeek)
        + (totalMonths * selectedVehicleClassData?.distanceLimitperMonth);

    return includedMiles;
}

export const getTheTotalAmountAfterDiscount = (totalAmountOfSelectedVehicleClass: number, totalDiscountAmount: number) => {
    let totalAmount = 0.0;

    totalAmount = totalAmountOfSelectedVehicleClass - totalDiscountAmount;

    return totalAmount;
}

export const getTheTotalDiscountAmount = (addedDiscountList: any[]) => {
    let discountAmount = 0.0;
    addedDiscountList
        ?.filter((item: any) => item?.discountApplied)
        ?.forEach((item: any) => {
            discountAmount += parseFloat(item?.discount);
        });

    return discountAmount;
}

export const calulatedDiscountValue = (discount: number, discountType: string, totalAmountOfSelectedVehicleClass: number) => {
    let discountAmount = 0.00;

    if (discountType === "Amount") {
        discountAmount = discount;
    } else {
        discountAmount = (totalAmountOfSelectedVehicleClass * discount) / 100;
    }

    return discountAmount;
}

//To Get the branch Timezone
export const branchTimezone = (formattedCreatedAt: string) => {
    const UpdateTimezone =
        formattedCreatedAt !== "" &&
            formattedCreatedAt !== null &&
            formattedCreatedAt !== "string" &&
            formattedCreatedAt !== "null"
            ? new Date().toLocaleString("en-US", {
                timeZone: formattedCreatedAt?.split(" ")[2],
            })
            : new Date().toLocaleString("en-US", {
                timeZone: moment.tz.guess(),
            });

    return UpdateTimezone;
}